/**
 * Variável de controle global: qual banco de dados a aplicação está usando.
 *
 * - "cloud"   → banco cloud do provedor (padrão)
 * - "externo" → banco Postgres independente ("sorvete"), configurado em /parametros
 *
 * O valor vem da tabela conexao_externa (campo "ativo"), portanto vale para
 * todos os usuários ao mesmo tempo.
 */
export type ModoBanco = "cloud" | "externo";

// Valor inicial vindo do arquivo config/banco.config.json (injetado no build), para
// que a primeira consulta já vá para o banco correto.
let modo: ModoBanco = typeof "externo" === "string" ? "externo" : "cloud";
const ouvintes = new Set<(m: ModoBanco) => void>();

export function bancoAtual(): ModoBanco {
  return modo;
}

export function usandoBancoExterno(): boolean {
  return modo === "externo";
}

export function definirBancoAtual(novo: ModoBanco) {
  if (modo === novo) return;
  modo = novo;
  for (const f of ouvintes) f(novo);
}

export function observarBancoAtual(f: (m: ModoBanco) => void): () => void {
  ouvintes.add(f);
  return () => ouvintes.delete(f);
}
